import './app/support';
import HeaderController from './app/components/Header/HeaderController';

import ServicesOnMap from './app/components/ServicesOnMap';
import RegionPicker from './app/components/RegionPicker';
import ProductComparison from './app/components/ProductComparison';
import ContactForm7 from './app/components/ContactForm7';

import { initCommonScripts, initMissingImageSubstitution } from './app/common-scripts';
import { initAffiliateMap } from './affiliate-map';

const $   = jQuery,
      RES = window.RES;


class Theme {
    constructor() {
        this.header = new HeaderController();
        this.regionPicker = new RegionPicker();
        this.forms7 = $('.wpcf7[role="form"]').toArray().map(f => new ContactForm7($(f)));
        this.som = $('#services-on-map').toArray().map(s => new ServicesOnMap($(s)));
        this.productComparisons = $('.productComparison').toArray().map(s => new ProductComparison($(s)));

        initCommonScripts();
        initAffiliateMap();

        if (RES.global('debug')) {
            window.theme = this;
            window.header = this.header;
            console.info('Theme:', this);
            console.info('Header:', this.header);
        }
    }
}

$(() => {
    new Theme();

    if (process.env.MIX_MISSING_IMAGE_SUBSTITUTION && process.env.MIX_MISSING_IMAGE_SUBSTITUTION_SOURCE) {
        console.log(`Replacing missing images URLs to production URLs from ${process.env.MIX_MISSING_IMAGE_SUBSTITUTION_SOURCE}`);
        initMissingImageSubstitution(process.env.MIX_MISSING_IMAGE_SUBSTITUTION_SOURCE);
    }
});
